import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="font-display text-4xl text-primary/40 animate-pulse">GYBC</div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function ActiveMemberRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  // Paid members who haven't completed payment (pending) are routed to finish joining.
  if (user.role !== "admin" && user.membership_status !== "active") {
    return <Navigate to={`/join?complete=1&tier=${user.tier || ""}`} replace />;
  }
  return children;
}

export function AdminRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
